import { Link } from "react-router-dom";

const STEPS = [
  { title: "Pilih trip", text: "Lihat detail gunung, harga per orang, durasi, dan fasilitas yang sudah termasuk." },
  { title: "Pilih tanggal", text: "Tentukan tanggal berangkat di kalender. Tanggal yang sudah terisi otomatis tertutup." },
  { title: "Isi data", text: "Masukkan nama, nomor WhatsApp, dan jumlah peserta. Kode pesanan langsung terbit." },
  { title: "Transfer & konfirmasi", text: "Transfer DP atau lunas ke rekening resmi, lalu konfirmasi lewat WhatsApp." },
];

export const HowItWorks = () => (
  <section className="border-y border-white/10 bg-black py-24 md:py-32" data-testid="home-how-it-works">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <p className="overline-label">Cara Pesan</p>
          <h2 className="mt-4 font-display text-4xl font-light sm:text-5xl">Empat langkah ke puncak.</h2>
        </div>
        <Link to="/cek-pesanan" className="text-sm text-neutral-400 underline-offset-4 hover:text-gold hover:underline" data-testid="how-link-check-order">
          Sudah pesan? Cek status pesanan
        </Link>
      </div>
      <div className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((step, i) => (
          <div key={step.title} className="group bg-ink-950 p-8 transition-colors duration-300 hover:bg-ink-850">
            <span className="font-mono text-sm text-gold">{String(i + 1).padStart(2, "0")}</span>
            <h3 className="mt-10 font-display text-2xl">{step.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-neutral-500">{step.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
